import { render, staticRenderFns } from "./QnaForm.vue?vue&type=template&id=fc37f7a6&"
import script from "./QnaForm.vue?vue&type=script&lang=ts&"
export * from "./QnaForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports